import mask from 'jquery-mask-plugin';

const lightbox = GLightbox({
    'selector': '.glightbox',
    'href': 'https://media-upload.net/uploads/lhX9u4YUWfzm.webm',
    'type': 'video',
    'source' : 'youtube',
    'width': 500,
});

$("[inputCard]").on('click', function () {
    let val = $(this).attr('type');
    $("#utility").attr('value', val);
});

$('[document]').mask('00.000.000/0000-00');
$('[phone]').mask('(00) 00000-0000');

gsap.set('#header', { display: 'none' });
gsap.set('footer#footer .footerTop__menu', { display: 'none' });
gsap.set('footer#footer .footerTop .footer_solution', { display: 'none' });
gsap.set('footer#footer .footerTop', { padding: '95px 0' });


let selectedCard = null;

document.addEventListener('DOMContentLoaded', (event) => {
    // Event listeners for next buttons
    document.getElementById('next1').addEventListener('click', () => {
        nextStep(2);
    });

    // Event listener for download button
    // document.getElementById('downloadButton').addEventListener('click', downloadContent);

    // Event listeners for cards
    const cards = document.querySelectorAll('#step1 .card');
    cards.forEach((card, index) => {
        card.addEventListener('click', () => selectCard(index));
    });

    // Event listener for the "Back" button
    document.getElementById('backToStep1')?.addEventListener('click', () => nextStep(1));

});

function nextStep(step) {
    for (let i = 1; i <= 3; i++) {
        const stepDiv = document.getElementById('step' + i);
        const indicator = document.getElementById('step' + i + 'Indicator');

        // Mostra ou esconde usando classes (CSP-safe)
        if (stepDiv) {
            if (i === step) {
                stepDiv.classList.remove('d-none');
                stepDiv.classList.add('d-flex');
            } else {
                stepDiv.classList.remove('d-flex');
                stepDiv.classList.add('d-none');
            }
        }

        // Indicadores
        if (indicator) {
            if (i < step) {
                indicator.classList.add('completed');
                indicator.classList.remove('active');
            } 
            else if (i === step) {
                indicator.classList.add('active');
                indicator.classList.remove('completed');
            } 
            else {
                indicator.classList.remove('active', 'completed');
            }
        }
    }

    // Reset the selected card if going back to the first step
    if (step === 1) {
        selectedCard = null;

        const cards = document.querySelectorAll('#step1 .card');
        cards.forEach(card => card.classList.remove('selected'));
    }
}


function selectCard(cardIndex) {
    const cards = document.querySelectorAll('#step1 .card');
    cards.forEach((card, index) => {
        const isSelected = index === cardIndex;
        card.classList.toggle('selected', isSelected);
        if (isSelected) {
            selectedCard = index;
        }
    });
}

function downloadContent() {
    // Implement download logic here
    alert("Download initiated!");
}

$("#step1").on("submit", function(e){
    e.preventDefault();
    form($(this))
});

$("#modalForm").on("submit", function(e){
    e.preventDefault();
    form($(this))
});



var swiper = new Swiper(".mySwiper", {
    slidesPerView: 'auto',
    spaceBetween: 14,
    freeMode: true,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });

function form(form)
{
    grecaptcha.ready(function () {
        grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
          action: 'submit'
        }).then(function (token) {
            var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
            var traffic_source = '';
            if (match) traffic_source = match[2];
            var data;
            var contentType = "application/x-www-form-urlencoded";
            var processData = true;
            $('.modalLoader').show();
            data = $(form).serialize()+'&gRecaptchaResponse='+ token +'&traffic_source='+ traffic_source;

            $.ajax({
                data: data,
                type: $(form).attr('method'),
                url: $(form).attr('action'),
                dataType: 'json',
                contentType: contentType,
                processData: processData,
                beforeSend: function () {
                    $(form).find('button').addClass('load');
                    $(form).find('input,button').prop("disabled", true);
                },
                success: function (data) {
                    $('.modalLoader').hide();
                    if (data.status) {
                        Swal.fire({
                        title: (data.title) ? data.title : jsi18n.ajax_success_title,
                        html: data.msgSuccess,
                        imageUrl: site_url + 'site/img/iconSuccess.png',
                        imageWidth: 76,
                        imageHeight: 76
                        });
                        $(form).find('input, button').prop("disabled", false);
                        $(form)[0].reset();
                        $(form).find('button').removeClass('load');
                        if ($(form).attr('formType') == 'download') {
                            nextStep(2);
                        }
                    } else {
                        Swal.fire({
                            title: jsi18n.form_invalid_title,
                            html: data.msgWarning,
                            imageUrl: site_url + 'site/img/iconError.png',
                            imageWidth: 76,
                            imageHeight: 76
                        });
                        $(form).find('input,button').prop("disabled", false);
                        $(form).find('button').removeClass('load');
                    }
                },
                error: function (data) {
                    $('.modalLoader').hide();
                    Swal.fire({
                    title: jsi18n.ajax_error_title,
                    text: jsi18n.ajax_error_message,
                    imageUrl: site_url + 'site/img/iconError.png',
                    imageWidth: 76,
                    imageHeight: 76
                    });
                    $(form).find('input,button').prop("disabled", false);
                    $(form).find('button').removeClass('load');
                }
            });
        });
    });
}

  // NEW FORM

const btnModal = document.querySelector('.btn-modal-form');
const modalForm = document.querySelector('.modal-form');
const btnCloseModal = document.querySelector('.close-btn');

btnModal.addEventListener('click', () => {
  modalForm.classList.remove('d-none');
  modalForm.classList.add('d-flex');
});

btnCloseModal.addEventListener('click', () => {
  modalForm.classList.remove('d-flex');
  modalForm.classList.add('d-none');
});





